import React from "react";
import { generatePath } from "react-router-dom";
import NavigationTabs, {
  NavigationTabDefinition,
} from "../components/NavigationTabs";
import API from "../api";
import { useResource } from "../useResource";
import { useParams } from "../util";
import EnvironmentConfigPage from "./EnvironmentConfigPage";
import EnvironmentActivityPage from "./EnvironmentActivityPage";
import EnvironmentAccessPage from "./EnvironmentAccessPage";
import EnvironmentLogsPage from "./EnvironmentLogsPage";
import { FeatureEnvPermissions } from "../globals";
import EnvironmentInfo from "./EnvironmentInfoPage";

export const environmentPagePath =
  "/projects/:project_name/environments/:environment_id/:tab?";

export default function EnvironmentPage() {
  const { project_name, environment_id, tab } = useParams(environmentPagePath);
  const [environment] = useResource(
    API.environments.read,
    environment_id,
    project_name
  );

  const tabs: NavigationTabDefinition[] = [
    {
      id: "info",
      label: "Info",
      page: (
        <EnvironmentInfo environment={environment} projectName={project_name} />
      ),
    },
    {
      id: "variables",
      label: "Variables",
      page: (
        <EnvironmentConfigPage
          projectName={project_name}
          environment={environment}
        />
      ),
    },
    {
      id: "activity",
      label: "Activity",
      page: (
        <EnvironmentActivityPage
          projectName={project_name}
          environment={environment}
        />
      ),
    },
    {
      id: "logs",
      label: "Logs",
      page: (
        <EnvironmentLogsPage
          projectName={project_name}
          environmentPk={environment.pk}
        />
      ),
    },
  ];

  if (FeatureEnvPermissions) {
    tabs.push({
      id: "access",
      label: "Access",
      page: (
        <EnvironmentAccessPage
          projectName={project_name}
          environment={environment}
        />
      ),
    });
  }

  return (
    <NavigationTabs
      basePath={generatePath(environmentPagePath, {
        project_name,
        environment_id,
      })}
      tabs={tabs}
      currentTabID={tab}
    />
  );
}
